export enum ErpSyncStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Completed = 'completed',
    PendingSummary = 'pending-summary',
    Failed = 'failed',
    Timeout = 'timeout',
}
